export default {
  state: {
    title: 'State',
    visible: 'Table ordering visible',
    on: 'Table ordering',
  },
  notes: {
    hidden: {
      title: 'Table ordering is hidden',
      description:
        "It's on, but your shop doesn't show it, so every table order is refused. Turn on “Table ordering visible” to show it.",
      link: 'Go to the switch',
    },
    off: {
      title: "Guests can't order at a table now",
      description:
        "Turn on both switches to start. Until then, a table's QR code opens your shop with Pickup and Delivery.",
    },
    no_active_table: {
      title: "Guests can't order at a table yet",
      description: 'Add a table below and switch it on.',
    },
  },
  buttons: {
    save: 'Save',
  },
};
